import type { AxiosResponse } from "axios";
import { createMutation } from "react-query-kit";

import type { ISendEmailInviteData } from "@api/videoVisit/types";
import type { ID } from "@constants";
import type { AxiosError, IApiResponse, IAxiosFn } from "@/api";
import { axiosClient } from "@/api";

type IResponse = AxiosResponse<IApiResponse<unknown>>;
type IVariables = { appointmentId: ID } & ISendEmailInviteData;

export const sendInviteEmail: IAxiosFn<IVariables, IResponse> = async ({
  appointmentId,
  ...data
}) => {
  return axiosClient.post(`video-visit/${appointmentId}/invite`, data);
};

export const useSendInviteEmail = createMutation<
  IResponse,
  IVariables,
  AxiosError
>({
  mutationFn: (data: IVariables) => sendInviteEmail(data),
});
